import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-turno',
  templateUrl: './combo-turno.component.html',
  styleUrls: ['./combo-turno.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ComboTurnoComponent implements OnInit {

  @ViewChild('comboTurno', {static: false}) comboTurno;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [
    { id: 1, tipo: 'Matutino', flag: 'M' },
    { id: 2, tipo: 'Vespertino', flag: 'V' },
    { id: 3, tipo: 'Noturno', flag: 'N' }
  ];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();
    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { flag: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
